import React, { useContext, useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { InfoContext } from "../providers/InfosContextProvider";

const SellProperty = () => {
  const { texts } = useContext(InfoContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));
    data.append("type", "selling");

    fetch("/api/send-email.php", {
      method: "POST",
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          setShowAlert(true);
          setShowError(false);
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });
        } else {
          setShowAlert(false);
          setShowError(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setShowAlert(false);
        setShowError(true);
      });
  };

  useEffect(() => {
    if (showAlert || showError) {
      const timer = setTimeout(() => {
        setShowAlert(false);
        setShowError(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert, showError]);

  useEffect(() => {
    const pageTitle = texts?.sellProperty?.title || "Vender";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);

  return (
    <>
      <Header />
      <Container className="sell-property">
        <div
          className="contact-card p-md-5 p-4 shadow-sm bg-white rounded-3"
          style={{ borderTop: "4px solid #a02020" }}
        >
          <h2
            className="mb-4 fw-bold"
            style={{
              color: "#333",
              borderBottom: "2px solid #f0f0f0",
              paddingBottom: "15px",
            }}
          >{`${texts.sellProperty.title}`}</h2>
          <p className="text-secondary" style={{ fontSize: "1.05rem" }}>
            {`${texts.sellProperty.subtitle}`}
          </p>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Label>{`${texts.sellProperty.name}`}</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder={`${texts.sellProperty.namePlaceholder}`}
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>{`${texts.sellProperty.email}`}</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder={`${texts.sellProperty.emailPlaceholder}`}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group controlId="phone" className="mb-3">
                  <Form.Label>{`${texts.sellProperty.phone}`}</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder={`${texts.sellProperty.phonePlaceholder}`}
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="message" className="mb-3">
              <Form.Label>{`${texts.sellProperty.message}`}</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="message"
                placeholder={`${texts.sellProperty.messagePlaceholder}`}
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button className="mt-3 btn-sell" type="submit">
                <FaEnvelope className="me-2" />
                {`${texts.sellProperty.send}`}
              </Button>
              {showAlert && (
                <Alert variant="success" className="mt-3">
                  {`${texts.sellProperty.msgOK}`}
                </Alert>
              )}
              {showError && (
                <Alert variant="danger" className="mt-3">
                  {`${texts.sellProperty.msgError}`}
                </Alert>
              )}
            </div>
          </Form>
        </div>
      </Container>
      <div className="div-footer">
        <Footer />
      </div>
    </>
  );
};

export default SellProperty;
